
import { Component, LOCALE_ID, Inject, ViewChild, ElementRef  } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { dasa } from 'src/classess/dasaClasses';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'dasaapp';
  languageList = [    { code: 'en', label: 'English' },   { code: 'ge', label: 'Deutsch' },    { code: 'fr', label: 'Français' }  ];
  @ViewChild("myBusyDiv") myBusyDiv: ElementRef =  {} as ElementRef;

   constructor(@Inject(LOCALE_ID) protected localeId: string, private router: Router) {

    }
    ngOnInit(): void {
      if (this.myBusyDiv.nativeElement != undefined) {
        this.myBusyDiv.nativeElement.style.display = 'none';
      }

      // Clear the global busy overlay whenever navigation settles.
      //
      // Screens call showBusy() before a request and hideBusy() inside the
      // subscribe's `next`. If the request errors, or the callback itself
      // throws, hideBusy() never runs and the spinner is stranded on top of
      // the app until a full reload — it then follows the user across routes,
      // because most screens never hide a spinner they did not show. That
      // pattern is repeated across ~40 components, so guarding each one is
      // unreliable; clearing it centrally once navigation completes fixes the
      // whole class, including future occurrences.
      this.router.events
        .pipe(filter(e => e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError))
        .subscribe(() => dasa.Utility.hideBusy());
    }
    ngAfterViewInit():void{
      dasa.Utility.busyDivObject = this.myBusyDiv.nativeElement ;
      dasa.Utility.hideBusy();
      this.myBusyDiv.nativeElement.style.display ='none' ;
    }
}
